<template>
  <v-container class="mt-10">
    <!-- Page Header -->
    <v-row justify="center">
      <v-col cols="12" md="8">
        <h1 class="text-center text-h4 font-weight-bold">
          Project Introduction
        </h1>
        <p class="text-center text-subtitle-1 mt-3">
          Welcome to our project! Below, you'll find an overview of what we're
          building.
        </p>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card class="elevation-4 pa-3">
          <v-card-title class="text-h5 font-weight-bold">
            Civic Innovation Challenge (CIVIC)</v-card-title
          >
          <v-card-text class="mt-1">
            <p style="font-size: 12pt; line-height: 2">
              This Civic Innovation Challenge (CIVIC) Stage 1 project funds
              research that involves the development, deployment, and refinement
              of a system for advancing community-centered, equitable, and
              sustainable solutions (ACCESS) for walking, biking, and
              micromobility infrastructure that is safe and accessible. The
              research team will develop an online visualization tool as the
              platform for a multilingual, AI-enhanced, data-driven process with
              broad participation in the biking and pedestrian Walking, biking,
              and micromobility infrastructure (e.g., sidewalks, curb ramps,
              bicycle lanes, accessible pedestrian signals) are critical for
              improving transportation equity and providing access to essential
              destinations to people of diverse demographic and socioeconomic
              status. They are particularly important for community members who
              are underserved by the car-centric transportation culture.
              However, the communication channel for voicing infrastructure
              needs is not always straightforward. The main challenge is the
              lack of data (e.g., mobility, accessibility, and safety data for
              identifying issues and building consensus), tools, and processes
              to support effective and efficient communication of infrastructure
              needs in both ways. Linguistic barriers (non-English speakers),
              low technological or professional literacy (unaware of or unable
              to articulate the need clearly), and lack of trust add additional
              difficulties in enabling the community of broad participation. The
              research team at George Mason University will integrate
              technological solutions in transportation data analytics, safety,
              interactive geographic interface, and multilinguistic generative
              AI with strong leadership from community partners to support
              effective communication and board participation of community
              members in the biking and pedestrian infrastructure planning
              process. The research team will work with various stakeholders to
              refine the research plan in the planning phase of this project.
              The new tools and processes help to remove various barriers to
              effective communication and develop efficient consensus-building
              mechanisms among the three types of stakeholders: agencies, users,
              and advocacy groups in the civic process.
            </p>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="primary"
              href="https://www.nsf.gov/awardsearch/showAward?AWD_ID=2431423&HistoricalAwards=false"
              target="_blank_"
              >Learn More</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  methods: {
    learnMore() {
      alert("More details coming soon!");
    },
  },
};
</script>

<style scoped>
h1 {
  color: #052477;
}
</style>
